import { shouldBypassAppLoader } from './shouldBypassAppLoader'
import type { ShouldHideAppLoaderParams } from './utils.interface'

export function shouldHideAppLoader({ isLoading, pathname, showOnSettings }: ShouldHideAppLoaderParams): boolean {
  if (!isLoading || shouldBypassAppLoader(pathname)) {
    return true
  }

  const isSettingsRoute = pathname?.includes('/settings') ?? false
  return isSettingsRoute && !showOnSettings
}
